import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class PropertySchools extends Vue {
   public title: string = 'PropertySchools';

   @Prop()
   public data: any;

   public displayData: any[] = [];

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         if (val instanceof Array && val.length > 0) {
            this.displayData = val;
            this.displayData.map((school) => {
               if (T_T.simpleDetect(school.type)) {
                  school.type = school.type.trim().toUpperCase() === 'AP' ? 'Advanced Placement' : school.type;
               }
            });
         }
      }
   }

   public roundKm(n: number) {
      return `${Math.round(n / 1000 * 10) / 100} km`;
   }
}
